import { render, staticRenderFns } from "./ReviewActions.vue?vue&type=template&id=f7fd8360"
import script from "./ReviewActions.vue?vue&type=script&lang=js"
export * from "./ReviewActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports